// Közös tengelyfelirat-formázók a Recharts grafikonokhoz (Fooldal, Statisztika).
// Cél: sosem kerülhet a képernyőre nyers lebegőpontos maradék (pl.
// 120.30000000000001) vagy mértékegység nélküli/rövidített felirat.

/** Kerekítés N tizedesjegyre, lebegőpontos maradék nélkül. */
export function roundForDisplay(value: number, decimals = 1): number {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
}

export function formatKgTick(value: number): string {
  return `${roundForDisplay(value, 1)} kg`;
}

export function formatGlucoseTick(value: number): string {
  return `${roundForDisplay(value, 1)} mmol/l`;
}

export function formatPercentTick(value: number): string {
  return `${roundForDisplay(value, 1)}%`;
}

export function formatDayTick(value: number): string {
  return `${Math.round(value)}. nap`;
}

export function formatWeekTick(value: number): string {
  return `${Math.round(value)}. hét`;
}
